import React, {Suspense, useEffect, useRef, useState} from 'react';
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as modulesState} from "../Redux/modules";
import {actionsState as projectState} from "../Redux/project";
import * as THREE from "three";
import {sendRedrawEvent, sendReselectEvent} from "../Helpers/Events";
import MaterialSelect from "./MaterialSelect";
import {getStrLang} from "../Helpers/functions";

const WallInfo = ({wall})=>{

    const dispatch = useDispatch();
    const [height,setHeight] = useState(wall.height);
    const [h,setH] = useState(wall.h);

    const [rMaterialWnd,setRMaterialWnd] = useState(false);
    const [lMaterialWnd,setLMaterialWnd] = useState(false);

    const [rMaterial,setRMaterial] = useState(wall.leftSide);
    const [lMaterial,setLMaterial] = useState(wall.rightSide);

    const _setRMaterial = (m)=>{
        wall.rightSide = m;
        setRMaterial(m);
    }

    const _setLMaterial = (m)=>{
        wall.leftSide = m;
        setLMaterial(m);
    }

    const _addWindow = ()=>{
        wall.addObject('window');
        sendReselectEvent(document.querySelector('#plan'));
    }
    const _canAddWindow = ()=>{
        return wall.canAddObject('window');
    }

    const _addDoor = ()=>{
        wall.addObject('door');
        sendReselectEvent(document.querySelector('#plan'));
    }
    const _canAddDoor = ()=>{
        return wall.canAddObject('door');
    }

    const remove = ()=>{
        ///dispatch(modulesState.remove(module))
    }


    const close = ()=>{
        dispatch(projectState.setModal(''));
    }

    const handlerH = event=>{
        setH(event.target.value);
        wall.h = event.target.value;
        sendRedrawEvent(document.querySelector('#plan'));
    }

    const handlerHeight = event=>{
        setHeight(event.target.value);
        wall.height = event.target.value;
    }

    useEffect(()=>{
        setH(wall.h);
        setHeight(wall.height);
    },[wall])

    return  <ModalWrapper
            // title={module.name}
            onDelete={()=>remove()}
            onClose={()=>close()}
            title={ getStrLang('c3d_l3lFS') }
        >
            <div className="modal-body">
                <div className="options-title">{ getStrLang('c3d_uzLRH') }</div>
                <div className="size-block">
                    <h2>{ getStrLang('c3d_NX1nX') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={h} onChange={handlerH} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
                <div className="size-block">
                    <h2>{ getStrLang('c3d_GNYpa') }</h2>
                    <div className="size-block-input">
                        <div className="size-minus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/></g></svg>
                        </div>
                        <input value={height} onChange={handlerHeight} type="text" />
                        <div className="size-plus">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34 34"><g strokeWidth="2px" stroke="currentColor"><line x1="8.5" y1="17.5" x2="24.5" y2="17.5"/><line x1="16.5" y1="9.5" x2="16.5" y2="25.5"/></g></svg>
                        </div>
                    </div>
                </div>
                <div className="materials-block">
                    <div className="options-title">{ getStrLang('c3d_aPNxt') }</div>
                    <div className="material-select">
                        <div className="material-select__name">{ getStrLang('c3d_lv9EQ') } 1</div>
                        <div className="material-select__select" onClick={()=>setLMaterialWnd(true)} style={{backgroundImage: 'url(' + lMaterial.userData.PICT + ')',cursor:'pointer'}}>
                            {/*<span>{wall.leftSide.userData.NAME}</span>*/}
                        </div>
                    </div>
                    {lMaterialWnd === true && <MaterialSelect
                        onClose={()=>setLMaterialWnd(false)}
                        active={wall.leftSide}
                        list={window.materials.wall}
                        setMaterial={_setLMaterial}
                        title={ getStrLang('c3d_lv9EQ')+' 1' }
                        notxt={true}
                    />}
                    <div className="material-select">
                        <div className="material-select__name">{ getStrLang('c3d_lv9EQ') } 2</div>
                        <div className="material-select__select" onClick={()=>setRMaterialWnd(true)} style={{backgroundImage: 'url(' + rMaterial.userData.PICT + ')',cursor:'pointer'}}>
                            {/*<span>{wall.rightSide.userData.NAME}</span>*/}
                        </div>
                    </div>
                    {rMaterialWnd === true && <MaterialSelect
                        onClose={()=>setRMaterialWnd(false)}
                        active={wall.leftSide}
                        list={window.materials.wall}
                        setMaterial={_setRMaterial}
                        title={ getStrLang('c3d_lv9EQ')+' 2' }
                        notxt={true}
                    />}
                </div>
                <div className="block">
                    <div className="options-title">{ getStrLang('c3d_GpQ7d') }</div>
                    <div className="wall-objects">
                        <div className="wall-objects-btn">
                            {_canAddWindow() && (
                                <div className="btn btn-icon"
                                     onClick={()=>{_addWindow();close()}}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                        <g fill="currentColor">
                                            <path d="M23.5,8h-12a1,1,0,0,0-1,1V26a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1V9A1,1,0,0,0,23.5,8Zm-1,6H18.45V10H22.5Zm-6.05-4v4H12.5V10ZM12.5,16h3.95v9H12.5Zm5.95,9V16H22.5v9Z"/>
                                        </g>
                                    </svg>
                                    { getStrLang('c3d_AhH1H') }</div>)}
                        </div>
                        <div className="block-list">
                            {wall.objects.map((element, index) => {if(element.isWindow) return (
                                <div className={"wall-objects-list"}>
                                    <div className={"wall-objects-list-name"}>{ getStrLang('c3d_UwRV5') } {element.id}</div>
                                    <span className="btn btn-delete"
                                          onClick={()=>{wall.removeObject(index);close()}}
                                          key={index}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><g fill="currentColor"><path d="M18.08,3.08H13.85V2.31A2.32,2.32,0,0,0,11.54,0H8.46A2.32,2.32,0,0,0,6.15,2.31v.77H1.92A1.92,1.92,0,0,0,0,5V7.69a.76.76,0,0,0,.77.77h.42l.66,14a2.32,2.32,0,0,0,2.31,2.2H15.84a2.32,2.32,0,0,0,2.31-2.2l.66-14h.42A.76.76,0,0,0,20,7.69V5a1.92,1.92,0,0,0-1.92-1.92ZM7.69,2.31a.77.77,0,0,1,.77-.77h3.08a.77.77,0,0,1,.77.77v.77H7.69ZM1.54,5a.38.38,0,0,1,.38-.38H18.08a.38.38,0,0,1,.38.38V6.92H1.54ZM16.61,22.34a.77.77,0,0,1-.77.74H4.16a.77.77,0,0,1-.77-.74L2.73,8.46H17.27Z"></path><path d="M10,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,10,21.54Z"></path><path d="M13.85,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.77.77,0,0,0,13.85,21.54Z"></path><path d="M6.15,21.54a.77.77,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,6.15,21.54Z"></path></g></svg></span>
                                </div>
                            )})}
                        </div>
                    </div>
                </div>
                <div className="block">
                    <div className="options-title">{ getStrLang('c3d_xjCX6') }</div>
                    <div className="wall-objects">
                        <div className="wall-objects-btn">
                            {_canAddDoor() && (
                                <div className="btn btn-icon"
                                     onClick={()=>{_addDoor();close()}}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                                        <g fill="currentColor">
                                            <path d="M23.5,27h-12a1,1,0,0,1-1-1V9a1,1,0,0,1,1-1h12a1,1,0,0,1,1,1V26A1,1,0,0,1,23.5,27Zm-11-2h10V10h-10Z"/>
                                            <path d="M19.72,18.93a1.86,1.86,0,1,1,1.86-1.86A1.85,1.85,0,0,1,19.72,18.93Z"/>
                                        </g>
                                    </svg>
                                    { getStrLang('c3d_By2L8') }</div>)}
                        </div>
                        <div className="block-list">
                            {wall.objects.map((element, index) => {if(element.isDoor) return (
                                <div className={"wall-objects-list"}>
                                    <div className={"wall-objects-list-name"}>{ getStrLang('c3d_NY2m8') } {element.id}</div>
                                    <span className="btn btn-delete"
                                          onClick={()=>{wall.removeObject(index);close()}}
                                          key={index}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 25"><g fill="currentColor"><path d="M18.08,3.08H13.85V2.31A2.32,2.32,0,0,0,11.54,0H8.46A2.32,2.32,0,0,0,6.15,2.31v.77H1.92A1.92,1.92,0,0,0,0,5V7.69a.76.76,0,0,0,.77.77h.42l.66,14a2.32,2.32,0,0,0,2.31,2.2H15.84a2.32,2.32,0,0,0,2.31-2.2l.66-14h.42A.76.76,0,0,0,20,7.69V5a1.92,1.92,0,0,0-1.92-1.92ZM7.69,2.31a.77.77,0,0,1,.77-.77h3.08a.77.77,0,0,1,.77.77v.77H7.69ZM1.54,5a.38.38,0,0,1,.38-.38H18.08a.38.38,0,0,1,.38.38V6.92H1.54ZM16.61,22.34a.77.77,0,0,1-.77.74H4.16a.77.77,0,0,1-.77-.74L2.73,8.46H17.27Z"></path><path d="M10,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,10,21.54Z"></path><path d="M13.85,21.54a.78.78,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.77.77,0,0,0,13.85,21.54Z"></path><path d="M6.15,21.54a.77.77,0,0,0,.77-.77v-10a.77.77,0,0,0-1.54,0v10A.78.78,0,0,0,6.15,21.54Z"></path></g></svg></span>
                                </div>
                            )})}
                        </div>
                    </div>
                </div>
            </div>
        </ModalWrapper>
}

export default WallInfo
